
/**
 * @summary Common Bulk validation allows commonly used validation through out the bulk imports / uploaded
 * to use, this allows keeps the code reusable and scalable
 */

import { Response } from "@/store/responses/types";
import store from "@/store";
import { DeviceDetails } from "@/store/devices/types";

export const isValidGroup = (groupTitle: string): boolean => {
    return getGroup(groupTitle) != null;
}

export const getGroup = (groupTitle: string) => {
    const areas: { [id: number]: string } = store.state["areas"]?.areaDictionary ?? [];

    for (const [groupId, title] of Object.entries(areas)) {
        if (title == groupTitle) {
            return { groupId: +groupId, title };
        }
    }

    return null;
}

export const isValidResponse = (responseTitle: string): boolean => {
    const responses: Response[] = store.state["responses"]?.responses ?? [];
    return responses.find(x => x.title == responseTitle) ? true : false;
}

export const isValidDevice = (deviceTitle: string): boolean => {
    const devices: DeviceDetails[] = store.state["devices"]?.devices ?? [];
    return devices.find(x => x.title == deviceTitle) ? true : false;
}